function Kr(kr) {
	var langs = {
		season: "시즌",
		selectGameType: "경기 유형 선택",
		gameType: "경기유형",
		playerType: "선수유형",
		team: "팀",
		hitter: "타자",
		oppTeam: "상대팀",
		pitcher: "투수",
		recent6G: "최근6경기",
		pickOffs: "견제",
		pitcherTypes: "투수유형",
		batterTypes: "타자유형",
		detailSearch: "상세 조회",
		detailedFilter: "상세 조건",
		inning: "이닝",
		shortInning: "회",
		top: "초",
		bottom: "말",
		pitchType: "구종",
		runner: "주자",
		count: "카운트",
		hitType: "타격형태",
		playResult: "타격결과",
		search: "경기조회",
		regularSeason: "패넌트레이스",
		futuresSeason: "퓨쳐스",
		reserveSquad: "육성군",
		postSeason: "포스트시즌",
		majorScrimmage: "1군_연습경기",
		futuresScrimmage: "2군_연습경기",
		ExhibitionLeague: "시범경기",
		fallEduLeague: "교육리그",
		inning1: "1이닝",
		inning2: "2이닝",
		inning3: "3이닝",
		inning4: "4이닝",
		inning5: "5이닝",
		inning6: "6이닝",
		inning7: "7이닝",
		inning8: "8이닝",
		inning9: "9이닝",
		inning10: "10이닝",
		inning11: "11이닝",
		inning12: "12이닝",
		inning13: "13이닝",
		inning14: "14이닝",
		inning15: "15이닝",
		fastball: "직구",
		twoSeamer: "투심",
		cutter: "커터",
		slider: "슬라이더",
		curve: "커브",
		changeUp: "체인지업",
		fork: "포크",
		other: "기타",
		single: "단타",
		double: "2루타",
		triple: "3루타",
		homeRun: "홈런",
		itpHomeRun: "그라운드홈런",
		groundBall: "땅볼",
		flyBall: "뜬공",
		reachedOnErr: "실책출루",
		fielderChoice: "야선출루",
		doublePlay: "병살타",
		triplePlay: "삼중살",
		groundOut: "땅볼아웃",
		flyOut: "플라이아웃",
		lineOut: "직선타아웃",
		infieldFly: "인필드플라이아웃",
		foul: "파울",
		lineDrive: "라인드라이브",
		foulFlyOut: "파울희비아웃",
		sacFly: "희비아웃",
		sacBunt: "희번아웃",
		hittingObstruction: "타격방해",
		fieldingInter: "수비방해",
		runningObstruction: "주루방해",
		strikeOut: "삼진아웃",
		baseOnBalls: "볼넷",
		hitByPitch: "사구(HP)",
		notOutSafe: "낫아웃(세이프)",
		balk: "보크",
		wildPitch: "폭투",
		intentionalBB: "고의4구",
		passedBalls: "포일",
		buntFailedOut: "3번트아웃",
		noRunner: "주자없음",
		runner1st: "1루",
		runner2nd: "2루",
		runner3rd: "3루",
		runner1st2nd: "1-2루",
		runner1st3rd: "1-3루",
		runner2nd3rd: "2-3루",
		baseLoaded: "만루",
		standing: "스탠딩",
		hitting: "타격",
		strikeSwinging: "헛스윙",
		buntPlay: "번트",
		pick1st: "1루견제",
		pick2nd: "2루견제",
		pick3rd: "3루견제",
		pickHome: "홈견제",
		catcherPick1st: "포수1루견제",
		catcherPick2nd: "포수2루견제",
		catcherPick3rd: "포수3루견제",
		selectTeamNPlayer: "팀 및 선수 선택",
		player: "선수",
		sortBy: "정렬",
		selectAll: "전체선택",
		desc: "최신순",
		asc: "경기순",
		watchClip: "선택보기",
		gameSeq: "차전",
		gameDate: "일자",
		away: "원정",
		score: "득점",
		home: "홈",
		clipType: "영상유형",

		pitch: "투구",
		pitchSpeed: "구속",
		result: "결과",
		watchType: "재생방법:",

		retrieveGames: "경기를 조회해 주십시오.",
		notExistGame: "경기가 없습니다.",

		forStaff: "코치용",
		caption: "자막",
		repeat: "반복",
		sequence: "순차",
		justplay: "전체",

		battedBallRanks: "타구랭크",
		rankNone: "없음",
		rankA: "A",
		rankB: "B",
		rankC: "C",

		leftPitcher: "좌투",
		rightPitcher: "우투",
		sidePitcher: "사이드",

		leftBatter: "좌타",
		rightBatter: "우타",

		battedBallType: "타구유형",

		minBallSpeed: "구속 시작값",
		maxBallSpeed: "구속 종료값",
		"~100": "~100",
		"100": "100",
		"105": "105",
		"110": "110",
		"115": "115",
		"120": "120",
		"125": "125",
		"130": "130",
		"135": "135",
		"140": "140",
		"145": "145",
		"150": "150",
		"155": "155",
		"160": "160",
		"165": "165",
		"165~": "165~"
	};

	return langs;
}

export default Kr;
